import _ from 'lodash';
import { createBrowserHistory } from 'history';

import { path, mergeUrl, getQueryParams } from 'utils/url';

export const history = createBrowserHistory();


// ======================
// HELPERS
// ====================== 
export const newTab = (url, params) => window.open(mergeUrl(url, params))
export const pushTo = (url, params) => history.push(path(url, params))

export const replaceTo = (url, params) => dispatch => 
  dispatch(routerActions.replace(path(url, params))); 

export const changeTo = (url, params, replace = false) => replace 
  ? replaceTo(url, params) 
  : pushTo(url, params);

export const pathTo = (url, params) => path(url, params)
export const linkEditUrl = (linkId, params) => mergeUrl(`/dashboard/link/${linkId ? linkId : 'create'}`, params);
export const currentPath = (location = window.location) => location.pathname + location?.search;

// ===========================
// ACTIONS
// ===========================
export const SET_ROUTE = 'SET_ROUTE';
export const NAVIGATE = 'NAVIGATE';



// ===========================
// SELECTORS
// ===========================
export const selectRoute = (state, key) => state.route;
export const selectQuery = (state, key) => state.route?.query?.[key];
export const selectParam = (state, key) => state.route?.params?.[key];
export const selectData = (state, key) => state.route?.data?.[key];


// ======================
// MODEL
// ====================== 

const SPEC = {
  url: null,
  params: {},
  query: {},
};

const RouteState = {
  actions: {
    back: () => dispatch => {
      history.goBack()
    },
    
    updateQueryParams: params => dispatch => {
      var u = mergeUrl(window.location.pathname, params);
      pushTo(u);
    },
    
    goToHome: params => dispatch => pushTo(`/${location?.search}`, params),

    setRoute: (location, params) => dispatch => {
      let url = location.href;
      let query = getQueryParams(location.search);
      let path = location.pathname;
      return dispatch({
        type: SET_ROUTE,
        url,
        params,
        query,
        path,
      })
    }
    ,

    navigate: (url, params, query, data) => dispatch => {
      pushTo(url, {...params, ...query});
      return dispatch({
        type: NAVIGATE,
        url,
        path,
        params,
        query: _.mapValues(query, _.toString),
        data,
      });
    },

    newTab: (url, params) => dispatch => {
      window.open(path(url, params));
    }
  },


  reducer(state = SPEC, action) {
    let { result, url, body, json, type } = action;

    switch(type) {
      case SET_ROUTE:
        return {
          url: action.url,
          params: action.params ?? {},
          query: action.query ?? {},
          path: action.path ?? '',
        };
      case NAVIGATE:
        return {
          url: action.url,
          params: action.params ?? {},
          query: action.query ?? {},
          data: action.data ?? {},
        };
        
    }
    return state;
  },
};
export default RouteState;


